import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {TabsDataService} from './tabs-data.service';
import {superAdminService} from './superAdminService';
import {SelectedQnrService} from './selected-qnr.service';

@Injectable()
export class NavigateUrlService {

  constructor(private router: Router,private tabsDataService:TabsDataService,private superAdminService:superAdminService,private selectedQnrService:SelectedQnrService) { }

  navigateToUrl(successPath,failPath)
  {
  let browserStorage = localStorage.getItem('browserStorage');
    if(browserStorage!=undefined && browserStorage!=null)
    {
      let tokens= JSON.parse(localStorage.getItem('browserStorage'));
      // console.log(tokens);
      if(tokens!= undefined || tokens!= ''){

        if(successPath!=''){
          this.router.navigateByUrl('/'+successPath);
        }
        if(this.router.url=='/dashboard')
        {
          this.router.navigateByUrl('/questionnaires');
        }
      }
    }
    else {
      this.removeStorageData();
      this.router.navigateByUrl(failPath);
    }
  }

  removeStorageData(){
    this.superAdminService.setData(undefined);
    this.selectedQnrService.setQnr(null,null);
    localStorage.removeItem('browserStorage');
    localStorage.removeItem('superAdminID');
    localStorage.removeItem('user_name_header');
    this.tabsDataService.setSurveyTabDataTobeUpdated(true);
    this.tabsDataService.setSurveyorDataTobeUpdated(true);
    this.tabsDataService.setTeamsTabDataTobeUpdated(true);
    this.tabsDataService.setDateLevelAnalyticsDataTobeUpdated(true);
    this.tabsDataService.setDateUserAnalyticsDataTobeUpdated(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/navigate-url.service.ts